import { render } from "./ViewingCardLayout.vue?vue&type=template&id=ea3dac16&scoped=true"
const script = {}

import "./ViewingCardLayout.vue?vue&type=style&index=0&id=ea3dac16&lang=postcss&scoped=true"

import exportComponent from "/var/www/keyvue-customer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3dac16"]])

export default __exports__